export default "__VITE_ASSET__CPCf5Xtd__"